module.exports = __webpack_public_path__ + "img/FaqSpurDemo0.859c3863.gif";